import styled from "@emotion/styled"
import { Container, Typography } from "@mui/material"
import * as api from "api"
import Banner from "common/Banner"
import { GlobalContext } from "common/GlobalContext"
import SeoMetaData, { seoKeys } from "common/SeoMetaData"
import { StaticPropsFactoryProps } from "common/StaticPropsFactory"
import VehicleModelExtended from "components/Vehicle/VehicleModelExtended"
import { GetStaticProps } from "next"
import { useContext } from "react"

const Styled = {
  Wrapper: styled.div`
    text-align: left; /* flipped by mui */
  `,
  Header: styled(Typography)`
    font-size: 34px;
    font-weight: bold;
    color: ${(p) => p.theme.colors.white};
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 54px;
    }
  `,
  Description: styled(Typography)`
    font-size: 12px;
    font-weight: 500;
    color: ${(p) => p.theme.colors.white};
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 16px;
    }
  `,
  VehicleContainer: styled(Container)`
    padding: 42px 0;
    ${(p) => p.theme.breakpoints.up("md")} {
      padding: 40px 15px 70px;
    }
  `,
}

type TransitPricesProps = StaticPropsFactoryProps & {
  data: (api.Vehicle | api.CustomVehicle | api.FVehicle | api.TransitVehicle)[]
}

export const getStaticProps: GetStaticProps<
  TransitPricesProps,
  any
> = async () => {
  const seo = await api.getSeoKey(seoKeys.transitPrices).then(api.extractData)
  const data = await api.getVehicle().then(api.extractData)
  return { props: { seo, data }, revalidate: 60 }
}

const TransitPrices = ({ seo, data }: TransitPricesProps) => {
  const { settings } = useContext(GlobalContext)
  return (
    <Styled.Wrapper>
      <SeoMetaData data={seo} />
      <Banner
        url="/images/car-prices-banner.jpg"
        title={
          <>
            <Styled.Header variant="h1">מחירון מסחריות</Styled.Header>
            <Styled.Description>
              {settings.AnnualPriceCatalogText || ""}
            </Styled.Description>
          </>
        }
      />
      <Styled.VehicleContainer disableGutters>
        {data.map((vehicle, i) => (
          <VehicleModelExtended key={i} model={vehicle} />
        ))}
      </Styled.VehicleContainer>
    </Styled.Wrapper>
  )
}

export default TransitPrices
